import { render, staticRenderFns } from "./RFI.vue?vue&type=template&id=df738e7a&scoped=true&"
import script from "./RFI.vue?vue&type=script&lang=js&"
export * from "./RFI.vue?vue&type=script&lang=js&"
import style0 from "./RFI.vue?vue&type=style&index=0&lang=less&"
import style1 from "./RFI.vue?vue&type=style&index=1&id=df738e7a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df738e7a",
  null
  
)

export default component.exports